import { useUserContextStore } from 'scbk-services/shared-context/stores/userContextStore';
import { useSessionTimerStore } from './stores/sessionTimerStore';

// 기본 세션 시간 (10분)
const DEFAULT_SESSION_INTERVAL = 600;
const TIME_SQUARE = 10 * 100;

// 세션 연장 알림 시간(60초)
const DEFAULT_SESSION_ALERT_TIME = 60;

// 세션타이머 Interval (singleton)
let sessionTimerInterval: ReturnType<typeof setInterval>;

/**
 * 세션타이머 매니저
 */
export const sessionTimerManager = {
    start: (maxInterval: number | null) => {
        if (!useUserContextStore.getState().getCommonContext().custName) {
            return;
        }

        // 로그인시 세션시간 설정
        if (maxInterval) {
            useSessionTimerStore.getState().setSessionMaxInterval(maxInterval);
        }

        // 기존 타이머 제거
        if (!!sessionTimerInterval) {
            clearInterval(sessionTimerInterval);
        }

        const sessionTime: number = (maxInterval ?? DEFAULT_SESSION_INTERVAL) * TIME_SQUARE;
        const expiryTime = Date.now() + sessionTime;

        useSessionTimerStore.getState().setExpiryTime(expiryTime);

        sessionTimerInterval = setInterval(() => {
            sessionTimerManager.update();
        }, 1000);
    },

    update: () => {
        if (!useUserContextStore.getState().getCommonContext().custName) {
            clearInterval(sessionTimerInterval);
            useSessionTimerStore.getState().clearTime();
            return;
        }

        const now = Date.now();
        const expiryTime = useSessionTimerStore.getState().expiryTime;
        let remainingTime = null;

        if (expiryTime) {
            const diffTime = expiryTime - now;
            remainingTime = diffTime > 0 ? Math.floor(diffTime / 1000) : 0;

            if (remainingTime <= 0) {
                useSessionTimerStore.getState().expireSessionTimer();
            } else if (remainingTime <= DEFAULT_SESSION_ALERT_TIME) {
                useSessionTimerStore.getState().alertSessionTimer();
            }
        }

        useSessionTimerStore.getState().setRemainingTime(remainingTime);
    },

    restart: (force: boolean = false) => {
        // 세션 연장 안내 팝업이 호출될 경우 타이머 연장 하지 않음
        if (
            !force &&
            (useSessionTimerStore.getState().isAlertSession ||
                useSessionTimerStore.getState().isExpiredSession)
        ) {
            return;
        }

        useSessionTimerStore.getState().setIsAlertSession(false);
        useSessionTimerStore.getState().setIsExpireSession(false);
        sessionTimerManager.start(useSessionTimerStore.getState().sessionMaxInterval);
    },

    clear: () => {
        clearInterval(sessionTimerInterval);
        useSessionTimerStore.getState().clearTime();
    },

    expire: () => {
        useSessionTimerStore.getState().expireSessionTimer();
    },

    clearTimerStore: () => {
        useSessionTimerStore.getState().clearTime();
        useSessionTimerStore.getState().setIsAlertSession(false);
        useSessionTimerStore.getState().setIsExpireSession(false);
    },
};
